import { useMemo } from "react";

import type { InvoiceSystemSettingsQueryQuery } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandContainer, FeatureIslandHeader, FeatureIslandMain } from "@/components/features/_layouts";
import * as UseCase from "@/components/features/invoice-system-settings/model/use-case";

import type { ButtonProps } from "@/components/ui/button/button";
import { Button } from "@/components/ui/button/button";

import { InvoiceSystemSettingsMain } from "./components";
import { useActions } from "./hooks";

type Props = {
	data: InvoiceSystemSettingsQueryQuery;
};

export const InvoiceSystemSettingsPresenter = ({ data }: Props) => {
	const { viewModel, onSetViewModel, onUpdateInvoiceSystemSettings } = UseCase.useInitialized({ data });

	const { onChangeRegistrationStatus, onChangeRegistrationCode } = useActions(viewModel, onSetViewModel);

	const variant = useMemo<ButtonProps["variant"]>(
		() => (!viewModel.hasError && viewModel.isDirty ? "default" : "disabled"),
		[viewModel.hasError, viewModel.isDirty],
	);

	return (
		<FeatureIslandContainer>
			<FeatureIslandHeader
				title="インボイス制度に関する設定"
				rightChildren={
					<Button variant={variant} size="xl" onClick={onUpdateInvoiceSystemSettings}>
						保存
					</Button>
				}
			/>
			<FeatureIslandMain>
				<InvoiceSystemSettingsMain
					registrationStatus={viewModel.registrationStatus}
					registrationCode={viewModel.registrationCode}
					onChangeRegistrationStatus={onChangeRegistrationStatus}
					onChangeRegistrationCode={onChangeRegistrationCode}
				/>
			</FeatureIslandMain>
		</FeatureIslandContainer>
	);
};
